import {
  calculatePaginatedData,
  calculatePagesWithRowIndices,
} from "./leaseCompPaginationUtils";
import LeaseComparisonPage from "./LeaseComparisonPage";
import { useLeaseComparisonData } from "./useLeaseComparisonData";

/**
 * Lease Comparison Component
 *
 * This component manages lease comparison data and pagination.
 * Structure follows PropertyComparison pattern with:
 * - Data management via useLeaseComparisonData hook
 * - Height-based field pagination using leaseCompPaginationUtils
 * - Rendering multiple LeaseComparisonPage components
 * - Field visibility filtering based on leaseCompFieldRules
 *
 * Pagination algorithm:
 * 1. Horizontal pagination: Split lease comps into chunks (7 landscape / 4 portrait per page)
 * 2. Vertical pagination: Split fields based on available height (24px per field row)
 * 3. No content splitting needed - all fields are single-line
 */
const LeaseComparison = () => {
  // Load and process data
  const { leaseComps, visibleFields, maxLeaseComps, leaseCompOrders, mode, showPropertyPhoto } =
    useLeaseComparisonData();

  // Calculate paginated data using height-aware algorithm
  const paginatedData = calculatePaginatedData(
    leaseComps,
    visibleFields,
    maxLeaseComps,
    mode,
    showPropertyPhoto,
  );

  // Calculate continuous row indices for proper striping
  const pagesWithRowIndices = calculatePagesWithRowIndices(paginatedData);

  return (
    <>
      {pagesWithRowIndices.map(({ pageData, pageIndex, startingRowIndex }) => (
        <LeaseComparisonPage
          key={pageIndex}
          pageData={pageData}
          pageIndex={pageIndex}
          maxLeaseComps={maxLeaseComps}
          leaseCompOrders={leaseCompOrders}
          startingRowIndex={startingRowIndex}
          mode={mode}
        />
      ))}
    </>
  );
};

export default LeaseComparison;
